module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.ab48e5ed.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-italic-webfont.woff2
// module id = 275
// module chunks = 0